import type { ReactNode } from 'react';
import { cn } from '../lib/cn.js';
import { TONE_STYLES, type Tone } from '../status/tone.js';

export interface BadgeProps {
  tone?: Tone;
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}

/**
 * The pill used for every status, priority and health readout.
 * Geometry matches the design: 4px/10px padding, 6px gap, fully rounded.
 */
export function Badge({ tone = 'neutral', icon, children, className }: BadgeProps) {
  const style = TONE_STYLES[tone];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full py-1 pl-[7px] pr-2.5',
        'text-[12px] font-semibold leading-[1.1]',
        style.bg,
        style.fg,
        className,
      )}
    >
      {icon}
      {children}
    </span>
  );
}
